
import {
  GET_MATCH_CARD_IMPORTANT_MOMENTS_REQUEST,
  GET_MATCH_CARD_IMPORTANT_MOMENTS_SUCCESS,
  GET_MATCH_CARD_IMPORTANT_MOMENTS_FAILURE,
  GET_IMPORTANT_MOMENTS_PLAYER_REQUEST,
  GET_IMPORTANT_MOMENTS_PLAYER_SUCCESS,
  GET_IMPORTANT_MOMENTS_PLAYER_FAILURE,

  RESET_MATCH_CARD
} from 'Store/constants';
  
const initialState = {
  data: {},
  launch: {},
  isLoading: false,
  error: null
};
  
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MATCH_CARD_IMPORTANT_MOMENTS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_MATCH_CARD_IMPORTANT_MOMENTS_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case GET_MATCH_CARD_IMPORTANT_MOMENTS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    
    case GET_IMPORTANT_MOMENTS_PLAYER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_IMPORTANT_MOMENTS_PLAYER_SUCCESS:
      return { ...state, launch: { ...action.payload }, isLoading: false, error: null };
    case GET_IMPORTANT_MOMENTS_PLAYER_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
  
    case RESET_MATCH_CARD:
      return { ...initialState };
  
    default:
      return state;
  }
};